<template>
	<svg
		width="17px"
		height="14px"
		viewBox="0 0 17 14"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="actively speaking icon"
	>
		<title>Actively Speaking</title>
		<g
			id="ActivelySpeaking"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="ActivelySpeakingGroup"
				transform="translate(-811.000000, -24.000000)"
				:fill="fill"
				fill-rule="nonzero"
			>
				<g id="Group-8" transform="translate(799.000000, 15.000000)">
					<path
						d="M17.0446425,18.6390301 C20.152446,18.6390301 22.0892849,20.7086429 22.0892849,22.2115761 C22.0892849,22.7289793 21.7538194,23 20.798059,23 L20.798059,23 L13.2975555,23 C12.3354656,23 12,22.7289793 12,22.2115761 C12,20.7086429 13.9431684,18.6390301 17.0446425,18.6390301 Z M27.2593768,9.25238647 C28.354387,10.7984365 29,12.7818155 29,14.8760666 C29,16.9764772 28.3733757,18.9598562 27.2593768,20.4997467 C27.0821497,20.7584483 26.7593432,20.8262034 26.5251503,20.6660548 C26.2719688,20.4997467 26.2339915,20.185609 26.4175482,19.9207478 C27.4049562,18.5594846 27.9682852,16.7608925 27.9682852,14.8760666 C27.9682852,12.9974002 27.3733085,11.2234463 26.4175482,9.8313853 C26.2339915,9.56652413 26.2719688,9.25238647 26.5251503,9.0860783 C26.7656728,8.92592969 27.0821497,8.99368487 27.2593768,9.25238647 Z M24.7845271,10.8415535 C25.5947081,11.9194768 26.0441054,13.3669739 26.0441054,14.8760666 C26.0441054,16.3851593 25.5883786,17.8203372 24.7845271,18.9167392 C24.6073,19.1631217 24.3034822,19.2247173 24.0503006,19.0645687 C23.8034486,18.9044201 23.7654714,18.5902824 23.949028,18.3192617 C24.6073,17.3891679 25.006061,16.163415 25.006061,14.8760666 C25.006061,13.5948777 24.6009705,12.3752844 23.9553575,11.439031 C23.7654714,11.1618507 23.8034486,10.8538726 24.0503006,10.6875644 C24.3034822,10.5335754 24.6009705,10.595171 24.7845271,10.8415535 Z M17.050972,12.5041064 C18.3358684,12.5041064 19.4498672,13.5820297 19.4498672,15.0172077 C19.4498672,16.4708643 18.3421979,17.5980641 17.050972,17.5980641 C15.7534165,17.5980641 14.6520768,16.4708643 14.6457472,15.0295268 C14.6457472,13.606668 15.7597461,12.5041064 17.050972,12.5041064 Z M22.316007,12.4184013 C22.7970519,13.0466767 23.0818812,13.9521323 23.0818812,14.8760666 C23.0818812,15.8000009 22.7970519,16.711616 22.316007,17.3398914 C22.1324504,17.5801143 21.8286325,17.6293908 21.6007691,17.4754017 C21.3285989,17.2967744 21.2906217,16.9887963 21.4868374,16.7054565 C21.8286325,16.2434893 22.0375073,15.5659375 22.0375073,14.8760666 C22.0375073,14.1923552 21.834962,13.5086438 21.4931669,13.0528362 C21.2842921,12.7694964 21.3285989,12.4553587 21.6007691,12.2767314 C21.8286325,12.1289019 22.1324504,12.1720189 22.316007,12.4184013 Z"
						id="Actively-Speaking"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'ActivelySpeaking',
	props: {
		active: {
			type: Boolean,
			default: null,
		},
	},

	computed: {
		fill() {
			return this.active ? '#00DAB6' : '#BCBCBC'
		},
	},
}
</script>
